import {trans} from '@frontend/helpers'
import {mdiClose} from '@mdi/js'
import clsx from 'clsx'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'

interface Props {
    label: string
    className?: string
    showResetButton?: boolean
    disabled?: boolean
    onReset?: () => void
}

// Название фильтра объявлений.
export function FilterLabel(props: Props) {

    const {
        label,
        className = 'mb-2',
        showResetButton,
        disabled,
        onReset,
    } = props

    return (
        <div
            className={clsx(
                'fw-500 with-icon-flex justify-content-between',
                className
            )}
        >
            <span>{label}:</span>
            {onReset && showResetButton && !disabled && (
                <IconButton
                    path={mdiClose}
                    color="muted"
                    onClick={onReset}
                    size={18}
                    tooltip={trans().ads.list.filters.reset_filter}
                />
            )}
        </div>
    )
}
